import Dashboard from '@material-ui/icons/Dashboard';
// import HotTubIcon from "@material-ui/icons/HotTub";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import HotTubIcon from '@material-ui/icons/HotTub'
import FlightIcon from '@material-ui/icons/Flight'
import SettingIcon from '@material-ui/icons/Settings'
import TransactionIcon from '@material-ui/icons/History' 
// core components/views for Admin layout
import DashboardPage from './views/Dashboard/Dashboard.js';
import Orders from './views/Vendor/OrdersTableList';
import Setting from './views/Setting/EditSetting'
import FlightBooking from './views/Vendor/FlightBooking.js';
import Transactions from './views/Vendor/Transactions'

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    rtlName: 'لوحة القيادة',
    icon: Dashboard,
    component: DashboardPage,
    layout: '/vendor',
  },
  {
    path: '/orders',
    name: 'Orders',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: HotTubIcon,
    component: Orders,
    layout: '/vendor',
  },
  {
    path: '/flight-booking',
    name: 'Book Flight',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: FlightIcon,
    component: FlightBooking,
     layout: '/vendor',
  },
  {
    path: '/transactions',
    name: 'Transactions',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: TransactionIcon,
    component: Transactions,
    layout: '/vendor',
  },
  {
    path: '/setting',
    name: 'Settings',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: SettingIcon,
    component: Setting,
    layout: '/vendor',
  }
];

export default dashboardRoutes;
